import React, { useContext } from "react";
import {
    ModalContainer,
    Content,
    IconContainer,
    IconCircle,
    TextContainer,
    Title,
    Description,
    Footer,
    CancelButton,
    DownloadButton,
} from "./DownloadInstallerModal.styles";
import { ApplicationContext } from "../../../../../../components/ApplicationProvider";
import DownloadIcon from "../../../../../../images/Download.svg";
import { StyledModal } from "../../../Gateways.styles";

type DownloadInstallerModalProps = {
    open: boolean;
    onClose: () => void;
    onDownload: () => void | Promise<void>;
};

const DownloadInstallerModal: React.FC<DownloadInstallerModalProps> = ({
    open,
    onClose,
    onDownload,
}) => {
    const { t } = useContext(ApplicationContext);

    return (
        <StyledModal
            open={open}
            onClose={onClose}
            closeOnDimmerClick={false}
            data-testid="download-installer-modal"
        >
            <ModalContainer data-testid="download-installer-modal-container">
                <Content data-testid="download-installer-modal-content">
                    <IconContainer data-testid="download-installer-icon-container">
                        <IconCircle data-testid="download-installer-icon-circle">
                            <img
                                src={DownloadIcon}
                                alt="Download"
                                data-testid="download-installer-icon"
                            />
                        </IconCircle>
                    </IconContainer>

                    <TextContainer data-testid="download-installer-text-container">
                        <Title data-testid="download-installer-title">
                            {t("devices.gateways.gateway_card.download_installer")}
                        </Title>

                        <Description data-testid="download-installer-description">
                            {t("devices.gateways.gateway_card.download_confirmation")}
                        </Description>
                    </TextContainer>
                </Content>

                <Footer data-testid="download-installer-modal-footer">
                    <CancelButton
                        type="button"
                        onClick={onClose}
                        data-testid="download-installer-cancel-button"
                    >
                        {t("devices.cancel")}
                    </CancelButton>

                    <DownloadButton
                        type="button"
                        onClick={onDownload}
                        data-testid="download-installer-download-button"
                    >
                        {t("devices.download")}
                    </DownloadButton>
                </Footer>
            </ModalContainer>
        </StyledModal>
    );
};

export default DownloadInstallerModal;
